import { render, staticRenderFns } from "./Lifestyle1Template.vue?vue&type=template&id=7c93f106"
import script from "./Lifestyle1Template.vue?vue&type=script&lang=js"
export * from "./Lifestyle1Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports